var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsesIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#879494"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 2.5,
    r: 2.5,
    fill: "#879494"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 2.5,
    r: 2.5,
    fill: "#879494"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsesIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/ellipsesIcon.c0cb1d17.svg";
export { MemoForwardRef as ReactComponent };